import { ReactElement } from "react";

import { RouteObject } from "react-router-dom";

import { EmailViewer } from "pages/EmailViewer/EmailViewer";
import { ResearchAssistantPage } from "pages/ResearchAssistant/ResearchAssistant";

import { SecureRoute } from "./components/SecureRoute/SecureRoute";
import { AccountMapPages } from "./pages/AccountMap/AccountMap";
import { CompanyPages } from "./pages/Company/Company";
import { ContactUs } from "./pages/ContactUs/ContactUs";
import { DealCreator } from "./pages/DealCreator/DealCreator";
import { DealsPages } from "./pages/Deals/Deals";
import { EsgViews } from "./pages/EsgViews/EsgViews";
import { MonitoringPages } from "./pages/Monitoring/Monitoring";
import { NotificationSettingsPage } from "./pages/NotificationSettings/NotificationSettings";
import { ReportsDirectory } from "./pages/ReportsDirectory/ReportsDirectory";
import { ResearchViews } from "./pages/ResearchViews/ResearchViews";
import { Screener } from "./pages/Screener/Screener";
import { SearchResults } from "./pages/SearchResults/SearchResults";
import { SectorViews } from "./pages/SectorViews/SectorViews";

interface RemoteAppRouteConfig {
  element: ReactElement;
  isAuthProtected: boolean;
}

/**
 * Mapping of app HAProxy routes to their route configuration
 */
export const REMOTE_APP_ROUTE_CONFIGS: Record<string, RemoteAppRouteConfig> = {
  account: {
    element: <AccountMapPages />,
    isAuthProtected: false,
  },
  "contact-us": {
    element: <ContactUs />,
    isAuthProtected: false,
  },
  assistant: {
    element: <ResearchAssistantPage />,
    isAuthProtected: true,
  },
  deals: {
    element: <DealsPages />,
    isAuthProtected: true,
  },
  "email-viewer": {
    element: <EmailViewer />,
    isAuthProtected: true,
  },
  entity: {
    element: <CompanyPages />,
    isAuthProtected: true,
  },
  "esg-views": {
    element: <EsgViews />,
    isAuthProtected: true,
  },
  "market-segment": {
    element: <SectorViews />,
    isAuthProtected: true,
  },
  monitoring: {
    element: <MonitoringPages />,
    isAuthProtected: true,
  },
  "notification-settings": {
    element: <NotificationSettingsPage />,
    isAuthProtected: true,
  },
  reports: {
    element: <ReportsDirectory />,
    isAuthProtected: false,
  },
  research: {
    element: <ResearchViews />,
    isAuthProtected: false,
  },
  screener: {
    element: <Screener />,
    isAuthProtected: true,
  },
  "search-results": {
    element: <SearchResults />,
    isAuthProtected: true,
  },
  "deal-creator": {
    element: <DealCreator />,
    isAuthProtected: true,
  },
};

export const REMOTE_APP_ROUTES: RouteObject[] = Object.keys(
  REMOTE_APP_ROUTE_CONFIGS
).map((remoteAppRoute) => {
  const routeConfig = REMOTE_APP_ROUTE_CONFIGS[remoteAppRoute];
  return {
    path: `/${remoteAppRoute}/*`,
    element: routeConfig.isAuthProtected ? (
      <SecureRoute page={routeConfig.element} />
    ) : (
      routeConfig.element
    ),
  };
});
